import { render } from "./CruImported.vue?vue&type=template&id=936f1dd8&scoped=true"
import script from "./CruImported.vue?vue&type=script&lang=js"
export * from "./CruImported.vue?vue&type=script&lang=js"

import "./CruImported.vue?vue&type=style&index=0&id=936f1dd8&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936f1dd8"]])

export default __exports__